import Header from "@/components/header";
import { ActionIcon, Stack } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const SendAreaMessage = () => {
  // const [activePage, setPage] = useState(0);
  // const { ref, inView } = useInView({ threshold: 0.4 });
  // const { data, isLoading, hasNextPage, fetchNextPage } = useGetMessagesRequest(
  //   {
  //     params: {
  //       Count: 10,
  //       Skip: activePage * 10,
  //     },
  //   }
  // );

  // useEffect(() => {
  //   // fetchNextPage();
  // }, [activePage]);

  // useEffect(() => {
  //   if (inView) setPage((prev) => prev + 1);
  // }, [inView]);

  const navigate = useNavigate();

  return (
    <>
      <Stack h="100svh">
        <Stack>
          <Header showHome showBack title="لیست پیام ها" route="/dashboard" />
        </Stack>
        <Stack>
          {/* <Stack px="md" gap="xs">
            <Badge>تعداد کل : {data?.pages[0]?.count}</Badge>

            {isLoading ? (
              <LoadingOverlay visible={isLoading} />
            ) : (
              data?.pages?.map((page) =>
                page?.result?.map((message) => <MessageItem item={message} />)
              )
            )}
            {!isLoading && hasNextPage && (
              <div ref={ref}>
                <Center>
                  <Loader type="dots" />
                </Center>
              </div>
            )}
          </Stack> */}
        </Stack>
      </Stack>
      <ActionIcon
        variant="filled"
        radius="xl"
        size="xl"
        onClick={() => navigate("selectUser")}
        aria-label="Settings"
        styles={{
          root: {
            position: "absolute",
            bottom: "10px",
            right: "10px",
          },
        }}
      >
        <IconPlus style={{ width: "70%", height: "70%" }} stroke={1.5} />
      </ActionIcon>
    </>
  );
};

export default SendAreaMessage;
